import * as React from 'react'

import Box from '@mui/material/Box'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'

type Props = {
  hideOptional: boolean
  onChangeHideOptional: (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void
}

export function ShowRequiredFieldsToggle(props: Props) {
  const { hideOptional, onChangeHideOptional } = props

  return (
    <Box display="flex" alignItems="flex-end">
      <FormControlLabel
        data-test-id="show-required-fields-toggle"
        labelPlacement="end"
        label={<Typography variant="body2">Show required fields</Typography>}
        control={
          <Switch
            size="small"
            checked={hideOptional}
            onChange={onChangeHideOptional}
          />
        }
      />
    </Box>
  )
}
